import React, { useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import MainForget from './Main';
import Navbar from '../../components/common/Navbar';
import './style.css';

const ForgetRegistration = [0, 1];

function ForgetPassword() {
  const [selectForgerState, setSelectForgetState] = useState(
    ForgetRegistration[0],
  );
  const location = useLocation();
  const takenEmail = location?.state?.takenEmail?.length > 0 ? location.state.takenEmail : '';
  const [emailFromSignUp] = useState(takenEmail);

  const LoginRegistrationUI = useMemo(() => {
    if (selectForgerState === 0) {
      return (
        <MainForget
          emailFromSignUp={emailFromSignUp}
          setSelectForgetState={setSelectForgetState}
        />
      );
    } if (selectForgerState === 1) {
      return null;
    }
    return null;
  }, [selectForgerState, emailFromSignUp, setSelectForgetState]);

  return (
    <div className="main-forgetpassword-container">
      <Navbar />
      {LoginRegistrationUI}

    </div>
  );
}

export default ForgetPassword;
